import React from "react";
import { Switch, Route } from "react-router-dom";

// Pages
import HomePage from "../../pages/Home";
import PoliticianPage from "../../pages/Politician";
import AdminPage from "../../pages/Admin";
import AdminOverview from "../../pages/Overview";

import CodeInput from "../CodeInput/CodeInput";
import Reset from "../Reset/Reset";
import City from "../../pages/City/";
import FAQ from "../../pages/FAQ";

import ShareCity from "../../pages/Share/City";
import ShareParty from "../../pages/Share/Party";

import FourOFour from "../FourOFour";

const AppRouter = () => (
  <Switch>
    <Route exact path="/" component={HomePage} />
    <Route exact path="/politicus/:code" component={PoliticianPage} />
    <Route exact path="/politicus" component={PoliticianPage} />
    <Route exact path="/code/:code" component={CodeInput} />
    <Route exact path="/indienen" component={AdminPage} />
    <Route exact path="/overzicht" component={AdminOverview} />
    <Route exact path="/reset/:wrongcode" component={Reset} />
    <Route exact path="/reset" component={Reset} />
    <Route exact path="/faq" component={FAQ} />

    <Route path="/gemeente/:city/:party?/:emoji?" component={City} />
    <Route path="/shareCity/:city" component={ShareCity} />
    <Route path="/shareParty/:city/:party" component={ShareParty} />

    <Route component={FourOFour} />
  </Switch>
);

export default AppRouter;



// WEBPACK FOOTER //
// ./src/components/Router/Router.js